<template>
  <div id="pageDetail"></div>
</template>
<script>
// amis
import { simpleAes } from '@/util/util';
import { getDetail } from '@/api/amis/index';
export default {
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // @ts-ignore
      // eslint-disable-next-line no-undef

      let amis = amisRequire('amis/embed');
      // 路由有坑点，动态id抓不到
      const id = this.$route.path.split('/').pop();
      getDetail(id).then((res) => {
        let schema = {};
        try {
          schema = JSON.parse(res.data.data?.schema || '{}');
        } catch (error) {
          console.log(error);
        }
        if (res?.data?.css) {
          insertDynamicStyle('amis-css', res.data.css);
        }
        console.log(amis, schema);
        amis.embed(
          '#pageDetail',
          schema,
          { theme: 'cxd' },
          {
            fetcher: function ({ url, method, data, config, headers }) {
              config = config || {};
              config.headers = config.headers || headers || {};
              const userInfo = sessionStorage.getItem('iol8cloud-userInfo');
              const tokenInfo = sessionStorage.getItem(
                'iol8cloud-access_token',
              );

              let staffId;
              let token;

              try {
                staffId = JSON.parse(userInfo)?.content?.staffId;
                token = JSON.parse(tokenInfo)?.content;
              } catch (error) {
                console.log(error);
              }

              config.headers['Content-Type'] = 'application/json';
              config.headers['Authorization'] = 'Bearer ' + token; // token
              config.headers['UserId'] = simpleAes(staffId);

              if (method !== 'post' && method !== 'put' && method !== 'patch') {
                if (data) {
                  config.params = data;
                }
                return axios[method](url, config);
              } else if (
                data &&
                typeof data !== 'string' &&
                !(data instanceof Blob) &&
                !(data instanceof ArrayBuffer)
              ) {
                data = JSON.stringify(data);
                config.headers['Content-Type'] = 'application/json';
              }

              return axios[method](url, data, config);
            },
          },
        );
      });
    },
  },
  watch: {
    $route() {
      this.init();
    },
  },
};
</script>
